import React from "react";
import { FiX, FiArrowLeft } from "react-icons/fi";

export default function GiftCancel() {
  const params = new URLSearchParams(window.location.search);
  const coachId = params.get("coach");
  const coachUrl = coachId ? `/coach/${coachId}?tab=thanks` : "/";

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-white border rounded-2xl p-6 shadow-sm">
        
        <div className="flex items-center gap-3 text-red-600">
          <div className="h-10 w-10 rounded-full bg-red-100 flex items-center justify-center">
            <FiX />
          </div>
          <h1 className="text-xl font-semibold">Payment Cancelled</h1>
        </div>

        <p className="mt-4 text-gray-700 leading-relaxed">
          Your payment was cancelled.  
          No amount has been charged. You can try again anytime.
        </p>

        <div className="mt-6">
          <a
            href={coachUrl}
            className="px-4 py-2 rounded-lg bg-gray-900 text-white inline-flex items-center gap-2"
          >
            <FiArrowLeft /> Back to coach profile
          </a>
        </div>

        <p className="mt-6 text-xs text-gray-500">
          You can retry the gift from the coach profile page.
        </p>
      </div>
    </div>
  );
}
